interface WebhookEndpoint {
  id?: number;
  taxPayerId?: number;
  name?: string;
  url?: string;
  isActive?: boolean;
  eventTypes?: string[];
  rawSecret?: string; // only returned once on creation
  createdAt?: string;
  updatedAt?: string;
}

export interface WebhookEvent {
  id?: number;
  webhookEndpointId?: number;
  taxPayerId?: number;
  eventType?: string;
  entityType?: string;
  entityId?: number;
  status?: string;
  attemptCount?: number;
  lastAttemptAt?: string;
  lastResponseStatus?: number;
  lastResponseBody?: string;
  lastError?: string;
  deliveredAt?: string;
  createdAt?: string;
}

export const WEBHOOK_EVENT_TYPE_LIST: {
  value: string;
  label: string;
  group: string;
}[] = [
  { value: "invoice.approved", label: "Aprobada", group: "Factura" },
  { value: "invoice.cancelled", label: "Cancelada", group: "Factura" },
  { value: "invoice.pending", label: "Pendiente", group: "Factura" },
  { value: "invoice.error", label: "Error", group: "Factura" },

  { value: "receipt.approved", label: "Generado", group: "Recibo" },
  { value: "receipt.cancelled", label: "Cancelado", group: "Recibo" },
  { value: "receipt.pending", label: "Pendiente", group: "Recibo" },

  {
    value: "credit_note.approved",
    label: "Aprobada",
    group: "Nota de Crédito",
  },
  {
    value: "credit_note.cancelled",
    label: "Cancelada",
    group: "Nota de Crédito",
  },
  {
    value: "credit_note.pending",
    label: "Pendiente",
    group: "Nota de Crédito",
  },
  { value: "credit_note.error", label: "Error", group: "Nota de Crédito" },

  {
    value: "debit_note.approved",
    label: "Aprobada",
    group: "Nota de Débito",
  },
  {
    value: "debit_note.cancelled",
    label: "Cancelada",
    group: "Nota de Débito",
  },
  {
    value: "debit_note.pending",
    label: "Pendiente",
    group: "Nota de Débito",
  },
  { value: "debit_note.error", label: "Error", group: "Nota de Débito" },

  {
    value: "remission_note.approved",
    label: "Aprobada",
    group: "Nota de Remisión",
  },
  {
    value: "remission_note.cancelled",
    label: "Cancelada",
    group: "Nota de Remisión",
  },
  {
    value: "remission_note.pending",
    label: "Pendiente",
    group: "Nota de Remisión",
  },
  {
    value: "remission_note.error",
    label: "Error",
    group: "Nota de Remisión",
  },

  {
    value: "auto_invoice.approved",
    label: "Aprobada",
    group: "Autofactura",
  },
  {
    value: "auto_invoice.cancelled",
    label: "Cancelada",
    group: "Autofactura",
  },
  {
    value: "auto_invoice.pending",
    label: "Pendiente",
    group: "Autofactura",
  },
  { value: "auto_invoice.error", label: "Error", group: "Autofactura" },
];

export const WEBHOOK_ENTITY_TYPE_LIST: { value: string; label: string }[] = [
  { value: "invoice", label: "Factura" },
  { value: "receipt", label: "Recibo" },
  { value: "credit_note", label: "Nota de Crédito" },
  { value: "debit_note", label: "Nota de Débito" },
  { value: "remission_note", label: "Nota de Remisión" },
  { value: "auto_invoice", label: "Autofactura" },
];

export const newWebhookEndpoint = (taxPayerId?: number): WebhookEndpoint => ({
  taxPayerId,
  isActive: true,
  eventTypes: [],
});

export default WebhookEndpoint;
